export function time2minutes(time: Date): number {
    return time.getHours() * 60 + time.getMinutes();
}

export function time2seconds(time: Date): number {
    return time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds();
}
